export enum BrandName {
    FortySeas = '40Seas',
    Reevol = 'Reevol',
}

export interface BrandConfig {
    name: BrandName;
    displayName: string;
    website: string;
    termsUrl: string;
    privacyUrl: string;
    supportEmail: string;
    supportWhatsAppUrl: string;
    faviconUrl: string;
}

export const BRAND_40SEAS: BrandConfig = {
    name: BrandName.FortySeas,
    displayName: '40Seas',
    website: 'https://www.40seas.com/',
    termsUrl: 'https://40seas.com/terms-and-conditions',
    privacyUrl: 'https://40seas.com/privacy-policy',
    supportEmail: 'support@40seas.com',
    supportWhatsAppUrl: 'https://wa.me/13327338726',
    faviconUrl: 'https://static.40seas.com/favicon.ico',
};

export const BRAND_REEVOL: BrandConfig = {
    name: BrandName.Reevol,
    displayName: 'Reevol',
    website: 'https://www.reevol.com/',
    termsUrl: 'https://www.reevol.com/terms-and-conditions',
    privacyUrl: 'https://www.reevol.com/privacy-policy',
    supportEmail: 'support@reevol.com',
    // Intentionally the same WhatsApp number as 40Seas — shared support line.
    supportWhatsAppUrl: 'https://wa.me/13327338726',
    faviconUrl: '/favicon-reevol.svg',
};
